/*
 * MDB shim for Dropdown
 * Files currently importing this symbol from "mdbreact":
 * - src/Components/Custom/pageHeader.jsx
 * - src/Seating/Activities/activities-add.jsx
 * - src/Seating/Contacts/contact-edit.jsx
 * - src/Seating/Deliveries/deliveryList.jsx
 * - src/Seating/Patient/PatientViewComponents/liaisonModal.jsx
 * - src/Seating/Patient/PatientViewComponents/typeStatusContainer.jsx
 * - src/Seating/Patient/patientInformationView.jsx
 * - src/Seating/Users/userAdd.jsx
 * - src/Seating/Users/userEdit.jsx
 */

import { createContext, useMemo, useState } from "react";

export const DropdownContext = createContext(null);

export default function Dropdown({ children, isOpen, toggle, ...rest }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(isOpen) || Boolean(anchorEl);

  const contextValue = useMemo(
    () => ({
      anchorEl,
      setAnchorEl,
      open,
      toggle,
    }),
    [anchorEl, open, toggle],
  );

  return (
    <div {...rest}>
      <DropdownContext.Provider value={contextValue}>
        {children}
      </DropdownContext.Provider>
    </div>
  );
}
